import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Spinner, Stack, Table } from "react-bootstrap";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";

import { Link, useNavigate } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";
import moment from "moment";
import solisPowerApi from "../../api/solisPowerApi";
import ".././../assets/css/ListComponentsTable.css"
import { ROUTES } from "../../constants/webRouting";
import InfoPill from "../InfoPill";
import { titles } from "../../constants/CONSTANT";
import HandoverEdit from "./HandoverEdit";
import { DateRangePicker } from "rsuite";
import { formatDate } from "../../utils/helper";

const HandoverList = () => {
  const navigate = useNavigate();
  const [body, setBody] = useState();
  const [showCreateModal, setShowCreateModal] = useState();
  const [dateRange, setDateRange] = React.useState([
    // new Date(),
    // new Date()
  ]);

  async function fetchDataByDateRange() {
    if (Array.isArray(dateRange)) {
      const [fromDate, toDate] = dateRange;
      if (fromDate && toDate) {

        const result = await solisPowerApi.fetchHandoverByDateRange(formatDate(fromDate), formatDate(toDate));
        if (result) {
          setBody(result);
          // setContacts(result);
        }
      }
    } else {
      init();
    }
  }
  useEffect(() => {
    fetchDataByDateRange();
  }, [dateRange]);

  async function init() {
    const result = await solisPowerApi.fetchHandoverRecords();

    if (result) {
      setBody(result);
      // setContacts(result);
    } else {
      setBody([]);
      // setContacts([]);
    }
  }
  useEffect(() => {
    init();
  }, []);

  // Create table headers consisting of 4 columns.
  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.
  const header = [];
  if (!isMobile) {
    header.push(
      {
        title: "Offer Name",
        prop: "offer_name_label",
        isFilterable: true,
        cell: (row) => (
          <Link to={`${ROUTES.HANDOVER.LIST}/${row.id}`} state={row}>
            {row.offer_name_label}
          </Link>
        ),
      }, {
      title: "Order Name",
      prop: "order_name_label",
      isFilterable: true,
      cell: (row) => (
        <Link to={`${ROUTES.ORDER.LIST}/${row.orderid}`} >
          {row.order_name_label}
        </Link>
      ),
    },
      {
        title: "Pincode",
        prop: "pincode",
        isFilterable: true
      },
      {
        title: "City",
        prop: "city",
        isFilterable: true
      },
      {
        title: 'Handover Date',
        prop: "handover_date",
        cell: (row) =>
          (row.handover_date ? formatDate(row.handover_date) : ''),
        isFilterable: true
      },

    );
  } else {
    //for mobile device
    header.push({
      title: "Info",
      prop: "name",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link
            to={`${ROUTES.HANDOVER.LIST}/${row.id}`}
            state={row}
            style={{ width: "100%" }}
          >
            {row.firstname} {row.lastname}
          </Link>

          <span>
            <i className="fa-solid fa-phone"></i> {row.phone}
          </span>
          <span style={{ width: "80%" }}>
            <i className="fa-solid fa-envelope"></i> {row.email}
          </span>
        </div>
      ),
    });
  }


  const labels = {
    beforeSelect: " ",
  };

  const create = () => {
    // setShowCreateModal(true);
    navigate(ROUTES.HANDOVER.CREATE);
  };

  // const createOffer = () => {
  //         navigate(ROUTES.OFFER.CREATE);
  //     };

  return (
    <Container fluid>
      <DatatableWrapper
        body={(body && Array.isArray(body)) ? body : []}
        headers={header}
        paginationOptionsProps={{
          initialState: {
            rowsPerPage: 50,
            options: [5, 10, 15, 20, 30, 50]
          },
        }}
      >
        <Row className="align-items-end">
          <Col>
            <Filter classes={{ inputGroup: "", input: "", clearButton: "btn-custom" }} />
          </Col>
          <Col
            md={1}
          >
            <PaginationOptions labels={labels} />
          </Col>
          <Col>
            <DateRangePicker
              value={dateRange}
              onChange={(e) => { setDateRange(e) }}
              // format="dd/mm/yyyy"
              character=" – "
            />
          </Col>
          <Col className="py-1">
            <BrowserView>
              <div className="d-flex py-1 px-2 ">
                <InfoPill left="Total" right={body?.length} rightClasses="bg-custom text-white border-white fw-bold" leftClasses="bg-white text-danger fw-bold " />
              </div>
            </BrowserView>
          </Col>
          <Col
            xs={12}
            sm={6}
            lg={4}
            className="d-flex flex-col justify-content-end align-items-end"
          >
            <Stack direction="horizontal" gap={2}>
              <Button
                size="sm"
                className="btn-create"
                onClick={() => create(true)}
              >
                New Handover
              </Button>
            </Stack>
          </Col>
        </Row>

        <Table striped className="shadow rounded sm my-4" responsive={true}>
          <TableHeader classes={{ th: 'bg-custom text-white' }} />
          {
            (body && Array.isArray(body)) ?
              <TableBody />
              :
              <tbody className="">
                <tr>
                  <td colSpan={100} align="center">
                    <div>
                      <Spinner />
                    </div>
                  </td>
                </tr>
              </tbody>
          }
        </Table>
        <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
      </DatatableWrapper>
      {showCreateModal &&
        <HandoverEdit />
      }
    </Container>
  );
};

export default HandoverList;
